export var providers = {
    'crea-ticket': 'creaticket',
    bizandgo: 'bizandgo',
    vodafone: 'vodafone',
    redsys: 'redsys'
};
var subdomain = document.location.hostname.split('.').shift() || '';
// console.log('subdomain: ', subdomain)
export var provider = providers[subdomain] || providers['crea-ticket'];
// console.log('provider: ', provider)



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Providers.ts
// module id = 199
// module chunks = 0